// /api/favorite is the phone app's API and takes a Firebase ID token, so the
// website signs in to the same Firebase project in the browser. Accounts line up
// by email. The SDK is in its own chunk, loaded after the page is up.
const CONFIG = {
    apiKey: "AIzaSyBzKrw-TQHiMn0BQOX3CtZC-2LAzIlyPK0",
    appId: "1:423068014601:web:eda11ebd1ef121b4a840d8",
    messagingSenderId: "423068014601",
    projectId: "nomad-lyrics",
    authDomain: "nomad-lyrics.firebaseapp.com",
};

let loading = null;
let sdk = null;

export function preloadFirebase() {
    if (typeof window === "undefined") return Promise.resolve(null);
    loading ??= (async () => {
        const [{ initializeApp }, firebaseAuth] = await Promise.all([
            import("firebase/app"),
            import("firebase/auth"),
        ]);
        const auth = firebaseAuth.getAuth(initializeApp(CONFIG));
        await auth.authStateReady();
        sdk = { auth, ...firebaseAuth };
        return sdk;
    })();
    return loading;
}

const sameEmail = (a, b) => (a || "").toLowerCase() === (b || "").toLowerCase();

/** A token for the website's account, or null if Firebase isn't signed in to it. */
export async function firebaseToken(email) {
    const { auth, signOut } = sdk || (await preloadFirebase());
    if (!auth.currentUser) return null;
    if (email && !sameEmail(auth.currentUser.email, email)) {
        await signOut(auth);
        return null;
    }
    return auth.currentUser.getIdToken();
}

/**
 * Sign in to Firebase with Google. Call from a tap: browsers only allow the popup
 * then, which is why this doesn't wait on anything once the SDK has loaded.
 */
export async function connectFirebase(email) {
    const { auth, GoogleAuthProvider, signInWithPopup, signOut } = sdk || (await preloadFirebase());
    const provider = new GoogleAuthProvider();
    if (email) provider.setCustomParameters({ login_hint: email });

    const { user } = await signInWithPopup(auth, provider);
    if (email && !sameEmail(user.email, email)) {
        await signOut(auth);
        throw Object.assign(new Error("Different Google account"), { code: "wrong-account" });
    }
    return user.getIdToken();
}

/**
 * Website login: a token for the Firebase account, opening the popup if needed.
 * Null when the SDK isn't ready yet; waiting for it would lose the tap, and browsers
 * then block the popup. So nothing here may wait before the popup opens.
 */
export async function firebaseLogin() {
    if (!sdk) return null;
    const { auth, GoogleAuthProvider, signInWithPopup } = sdk;
    if (auth.currentUser) return auth.currentUser.getIdToken();
    const { user } = await signInWithPopup(auth, new GoogleAuthProvider());
    return user.getIdToken();
}

export async function signOutFirebase() {
    if (!loading) return;
    const { auth, signOut } = await loading;
    await signOut(auth);
}
